export const decodePid = (pid: string) => {
  if (pid.toLowerCase().startsWith('l:')) {
    return pid;
  }
  return decodeURIComponent(pid);
};

export const parseEncodedPid = (pid: string = '') => {
  const decodedPid = decodePid(pid);
  const [_, __, value] = decodedPid.split(':');

  return value;
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

/**
 * Extracts the pid from cookies or window.__NEXT_DATA__ (if available).
 */
export const extractPid = (): string | undefined => {
  const pid = getCookie('pid');
  if (Boolean(pid)) return pid;
  if (typeof window === 'undefined') return;
  return (window as any).__NEXT_DATA__?.props?.pid;
};
